'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Unsubscription;
exports.loadUnsubscription = loadUnsubscription;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_UNSUBSCRIPTION = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION';
var LOAD_UNSUBSCRIPTION_SUCCESS = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION_SUCCESS';
var LOAD_UNSUBSCRIPTION_FAIL = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION_FAIL';

var initialState = {
  loadedUnsubscription: false,
  loadingUnsubscription: false
};

function Unsubscription() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_UNSUBSCRIPTION:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: true
      });
    case LOAD_UNSUBSCRIPTION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: false,
        loadedUnsubscription: true,
        data: action.result
      });
    case LOAD_UNSUBSCRIPTION_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: false,
        loadedUnsubscription: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadUnsubscription(data) {
  return {
    types: [LOAD_UNSUBSCRIPTION, LOAD_UNSUBSCRIPTION_SUCCESS, LOAD_UNSUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.post('/notification/manual/unsubscription', {
        data: data
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/Unsubscription.js
// module id = 2417
// module chunks = 0